import Cookies from 'js-cookie';
import { TOKEN_KEY, COOKIE_TOKEN, COOKIE_CONSENT_TOKEN } from '../config';

export default class AuthStorage {
  static checkCookieConsent() {
    return !!this.get(COOKIE_CONSENT_TOKEN);
  }

  static saveTokens(authToken) {
    this.save(TOKEN_KEY, authToken);
    if (this.checkCookieConsent()) {
      this.saveCookie(COOKIE_TOKEN, authToken);
    }
  }

  static getToken() {
    return this.get(TOKEN_KEY);
  }

  static clear() {
    this.remove(TOKEN_KEY);
    this.removeCookie(COOKIE_TOKEN);
    if (this.get(COOKIE_CONSENT_TOKEN)) {
      this.remove(COOKIE_CONSENT_TOKEN);
    }
  }

  static get(key) {
    return localStorage.getItem(key);
  }

  static save(key, value) {
    localStorage.setItem(key, value);
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static saveCookie(key, value) {
    Cookies.set(key, value, { sameSite: 'strict', secure: true });
  }

  static removeCookie(key) {
    Cookies.remove(key);
  }
}
